import { Injectable } from "@angular/core";
import { SingleRunResolver } from "./single-run.resolver";
import { SharedInitService } from "./shared-init.service";

@Injectable({ providedIn: 'root' })
export class DocumentManagerInitResolver extends SingleRunResolver {

  constructor(private readonly sharedInitService: SharedInitService) {
    super();
  }

  protected runOnce() {
    return this.sharedInitService.initRagMatrix();
  }
}
